<template>
  <div>
    <div id="productModalBody" class="modal-body">
      <!-- 内容开始 -->
      <div id="kt_post" class="post d-flex flex-column-fluid">
        <!--begin::Container-->
        <div id="kt_content_container" class="container"
             style="padding:1px 1px 1px 1px;max-width:100%;flex-direction:row!important;display:flex;">
          <!-- 搜索开始 -->
          <div class="flex-column flex-lg-row-auto w-100 w-lg-250px w-xxl-400px ">
            <!--begin::Form-->
            <form action="#">
              <!--begin::Card-->
              <div class="card">
                <!--begin::Body-->
                <div class="card-body">
                  <!--begin:Search-->
                  <div class="position-relative">
                    <!--begin::Svg Icon | path: icons/duotone/General/Search.svg-->
                    <span class="svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 translate-middle ms-6">
                      <svg height="24px" version="1.1" viewBox="0 0 24 24"
                           width="24px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
                          <rect height="24" width="24" x="0" y="0"></rect>
                          <path
                              d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                              fill="#000000" fill-rule="nonzero" opacity="0.3"></path>
                          <path
                              d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                              fill="#000000" fill-rule="nonzero"></path>
                        </g>
                      </svg>
                    </span>
                    <!--end::Svg Icon-->
                    <input v-model="goodsQueryParams.orderNo" class="form-control form-control-solid ps-10" name="orderNo"
                           placeholder="请输入需要查询的订单号"
                           type="text" value="">
                  </div>
                  <!--end:Search-->

                  <!--begin:Search-->
                  <div class="position-relative" style="margin-top:20px;">
                    <!--begin::Svg Icon | path: icons/duotone/General/Search.svg-->
                    <span class="svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 translate-middle ms-6">
                      <svg height="24px" version="1.1" viewBox="0 0 24 24"
                           width="24px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
                          <rect height="24" width="24" x="0" y="0"></rect>
                          <path
                              d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                              fill="#000000" fill-rule="nonzero" opacity="0.3"></path>
                          <path
                              d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                              fill="#000000" fill-rule="nonzero"></path>
                        </g>
                      </svg>
                    </span>
                    <!--end::Svg Icon-->
                    <input v-model="goodsQueryParams.tel" class="form-control form-control-solid ps-10" name="tel"
                           placeholder="请输入需要查询的手机号"
                           type="text" value="">
                  </div>
                  <!--end:Search-->


                  <!--begin::Border-->
                  <div class="separator separator-dashed my-8"></div>
                  <!--end::Border-->
                  <!--begin::Input group-->
                  <div class="mb-5">
                    <label class="fs-6 form-label fw-bolder text-dark">下单时间</label>
                    <!--begin::Select-->
                    <div class="contract-manage">
                      <el-date-picker
                          v-model="orderDateRange"
                          :picker-options="pickerOptions"
                          align="right"
                          class="w-100"
                          end-placeholder="结束日期"
                          range-separator="至"
                          start-placeholder="开始日期"
                          type="daterange"
                          unlink-panels
                          value-format="yyyy-MM-dd"
                      >
                      </el-date-picker>
                    </div>


                  </div>
                  <!--end::Input group-->



                  <!--begin::Action-->
                  <div class="d-flex align-items-center justify-content-end">
                    <a class="btn btn-primary" @click="findProduct">筛选</a>&nbsp;&nbsp;&nbsp; <a
                      class="btn btn-active-light-primary btn-color-gray-400 me-3"
                      @click="resetQuery">重置</a>
                  </div>
                  <!--end::Action-->
                </div>
                <!--end::Body-->
              </div>
              <!--end::Card-->
            </form>
            <!--end::Form-->
          </div>
          <!-- 列表开始 -->
          <div class="card mb-5 mb-xl-8" style="margin-left:3px;width:100%;">
            <!--begin::Header-->
            <div class="card-header border-0 pt-5">
              <h3 class="card-title align-items-start flex-column">
                <span class="card-label fw-bolder fs-3 mb-1">订单列表</span>
              </h3>
              <div class="d-flex flex-wrap my-1">
                <!--begin::Tab nav-->
                <ul class="nav nav-pills me-6 mb-2 mb-sm-0">
                  <!-- 自营订单 -->
<!--                  <el-button :disabled="batchRemoveTopicBtnDisabled" size="small" style="background-color: #f46789;height:30px"-->
<!--                             type="danger" @click="batchRemoveGoodsFromTopic">批量移除-->
<!--                  </el-button>-->
                  <!-- 分销订单 -->
                </ul>
                <!--end::Tab nav-->
                <!--begin::Actions-->
                <div style="margin-right: 20px">
                  <!--begin::Select-->
                  <!--end::Select-->
                </div>
                <!--end::Actions-->

              </div>

            </div>
            <!--end::Header-->
            <!--begin::Body-->

            <div class="tab-content">
              <!--begin::Tab pane-->
              <div id="kt_project_users_card_pane2" class="tab-pane fade active show">
                <!--begin::Card-->
                <div class="card card-flush">
                  <!--begin::Card body-->
                  <div class="card-body pt-0">
                    <!--begin::Table container-->
                    <div class="table-responsive tableProduct">
                      <!--begin::Table-->
                      <el-table id="tableProduct" ref="topicGoodsTable" :data="topicGoodsList"
                                empty-text="未查询到数据"
                                @selection-change="handleSelectionChange">
                        <template #empty>
                          未查询到数据
                        </template>
<!--                        <el-table-column-->
<!--                            type="selection" width="50">-->
<!--                        </el-table-column>-->

                        <el-table-column
                            label="订单号"
                            width="180"
                        >
                          <template slot-scope="scope">
                            <a class="text-dark fw-bolder d-block mb-1 fs-7">{{ scope.row.orderNo }}</a>
                          </template>
                        </el-table-column>

                        <el-table-column
                            label="商品信息"
                            width="300"
                        >
                          <template slot-scope="scope">
                            <div class="d-flex align-items-center">
                              <div class="symbol symbol-50px me-5"><img :src="scope.row.picUrl"
                                                                        alt="" class=""></div>
                              <div class="d-flex justify-content-start flex-column cursor-pointer"><a
                                  class="text-muted d-block fs-7"
                                 >{{ scope.row.title }} </a>
                              </div>
                            </div>
                          </template>
                        </el-table-column>

                        <el-table-column
                            label="购买人"
                            width="100"
                        >
                          <template slot-scope="scope">
                            <span class="text-muted d-block fs-7">{{
                                scope.row.userName
                              }}</span>
                          </template>
                        </el-table-column>

                        <el-table-column
                            label="成本价"
                            width="80"
                        >
                          <template slot-scope="scope">
                            <a class="text-dark fw-bolder d-block mb-1 fs-7">¥{{ scope.row.costPrice }}</a>
                          </template>
                        </el-table-column>

                        <el-table-column
                            label="市场价"
                            width="80"
                        >
                          <template slot-scope="scope">
                            <a class="text-dark fw-bolder d-block mb-1 fs-7">¥{{ scope.row.price }}</a>
                          </template>
                        </el-table-column>

                        <el-table-column
                            label="支付金额"
                            width="80"
                        >
                          <template slot-scope="scope">
                            <a class="text-dark fw-bolder d-block mb-1 fs-7">¥{{ scope.row.totalMoneySupply }}</a>
                          </template>
                        </el-table-column>

                        <el-table-column
                            label="分成类型"
                            width="100"
                        >
                          <template slot-scope="scope">
                            <a class="text-dark fw-bolder d-block mb-1 fs-7">{{ scope.row.bingType }}</a>
                          </template>
                        </el-table-column>

                        <el-table-column
                            label="分成金额"
                            width="80"
                        >
                          <template slot-scope="scope">
                            <a class="text-dark fw-bolder d-block mb-1 fs-7">¥{{ scope.row.bindMoney }}</a>
                          </template>
                        </el-table-column>


                        <el-table-column
                            label="下单时间"
                        >
                          <template slot-scope="scope">
                            <a class="text-muted  d-block fs-7">{{ scope.row.crTime }}</a>
                          </template>
                        </el-table-column>
<!--                        <el-table-column
                            label="操作"
                        >
                          <template slot-scope="scope">
                            <a class="btn btn-danger   btn-sm px-4"
                               @click="removeProductFromShop(scope.$index)">移除</a>&nbsp;&nbsp;

                          </template>
                        </el-table-column>-->
                      </el-table>
                    </div>
                    <!--end::Table container-->
                    <!-- 分页按钮 -->
                    <el-pagination :current-page="goodsQueryParams.pageIndex"
                                   :page-size="goodsQueryParams.pageSize"
                                   :page-sizes="[10,20,30,50,100]" :total="totalCount"
                                   background
                                   layout="total, sizes, prev, pager, next, jumper"
                                   style="display:flex;justify-content:flex-end;margin-top: 5px" @size-change="handleSizeChange"
                                   @current-change="handleCurrentChange">
                    </el-pagination>
                  </div>
                </div>
                <!--end::Card body-->
              </div>
              <!--end::Card-->
            </div>
            <!--end::Tab pane-->
            <!-- 弹出框 -->
          </div>
          <!--begin::Body-->
        </div>
      </div>
      <!--end::Container-->
    </div>

  </div>
</template>
<script>

import {getCategoryList} from '@/api/categoryApi';
import {
  getVipOrderList,
  getVipOrderListCount,
} from '@/api/vipOrderApi';

import Pagination from "@/components/Pagination";
import sd from "silly-datetime";


export default {
  components: {
    Pagination,
  },
  props: {
    currentTopicId: {
      type: Number,
      default: null,
    }
  },
  data() {
    return {
      categoryOne: [],
      categoryTwo: [],
      shopGoodsGroupList: [],
      loading: false,
      viewType: 1,
      goodsQueryParams: {
        place: 2,
        pageIndex: 1,
        pageSize: 10,
        title: "",
        supplyTel: "",
        minSupplyPrice: null,
        maxSupplyPrice: null,
        categoryId1: null,
        categoryId2: null,
        groupId: null,
        bindId: this.currentTopicId,
        orderNo:'',
        // 订单日期
        startTime: "",
        endTime: "",
        tel:'',
      },
      topicGoodsList: [],
      totalCount: 0,
      multipleSelection: [],
      userRole: localStorage.getItem('role'),
      orderDateRange: [],
    };
  },
  methods: {
    //重置
    resetQuery() {
      this.goodsQueryParams = {
        place: 2,
        pageIndex: 1,
        pageSize: 10,
        title: "",
        supplyTel: "",
        minSupplyPrice: null,
        maxSupplyPrice: null,
        categoryId1: null,
        categoryId2: null,
        groupId: null,
        bindId: this.currentTopicId,
        startTime: "",
        endTime: "",
        orderNo:"",
        tel:'',
      };
      this.getChooseGoodsList()
    },
    findProduct() {

      if (this.orderDateRange && this.orderDateRange.length > 0) {
        this.goodsQueryParams.startTime = sd.format(
            this.orderDateRange[0],
            "YYYY-MM-DD 00:00:00"
        );
        this.goodsQueryParams.endTime = sd.format(
            this.orderDateRange[1],
            "YYYY-MM-DD 00:00:00"
        );
      }

      this.goodsQueryParams.pageIndex = 1
      this.getChooseGoodsList();
    },
    async getChooseGoodsList() {

      let {data} = await getVipOrderList(this.goodsQueryParams);
      this.topicGoodsList = data;
      if (this.goodsQueryParams.pageIndex == 1) {
        const res = await getVipOrderListCount(this.goodsQueryParams);
        this.totalCount = res.data;
      }
      this.loading = false;
    },

    handleCurrentChange(param) {
      this.goodsQueryParams.pageIndex = param
      this.getChooseGoodsList();
    },
    handleSizeChange(param) {
      this.goodsQueryParams.pageIndex = 1
      this.goodsQueryParams.pageSize = param
      this.getChooseGoodsList();
    },
    async getPageCount() {
      // let { data } = await getChooseGoodsListCountApi(this.params);
      // this.totalCount = data;
    },
    toggleDropdown(index) {
      this.$nextTick(() => {
        const dropdown = document.getElementById(`dropdown-${index}`);
        new KTMenu(dropdown);
      });
    },

    //初始化分类
    async getCategory1List(parentId) {
      const {data} = await getCategoryList({parentId});
      this.categoryOne = data.list
    },
    async changeCategoryId1() {
      const categoryId1 = this.goodsQueryParams.categoryId1;
      console.log(categoryId1)
      this.goodsQueryParams.categoryId2 = null
      if (categoryId1 == "null") {
        this.categoryTwo = []
      } else {
        const param = {parentId: categoryId1};
        const {data} = await getCategoryList(param);
        this.categoryTwo = data.list
        console.log(data)
      }
    },
    viewMode(type) {
      this.viewType = type
      this.goodsQueryParams.pageIndex = 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length > 0) {
        this.batchRemoveTopicBtnDisabled = false
      } else {
        this.batchRemoveTopicBtnDisabled = true
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.topicGoodsTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.topicGoodsTable.clearSelection();
      }
    },

    //日期选择器 用
    pickerOptions: {
      shortcuts: [
        {
          text: "最近一周",
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          },
        },
        {
          text: "最近一个月",
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          },
        },
        {
          text: "最近三个月",
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          },
        },
      ],
    },



  },
  created() {
    this.getChooseGoodsList();
    this.getCategory1List(0);
  },
  mounted() {
  },
  updated() {
    // 当数据更新后，可以在此处手动初始化下拉菜单插件

  },
};
</script>

<style scoped>
/* 修改滚动条样式 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 20px; /* 设置滚动条宽度 */
  height: 10px;
  background-color: #F5F5F5; /* 设置滚动条背景颜色 */
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #999; /* 设置滚动条滑块颜色 */
  border-radius: 5px; /* 设置滚动条滑块圆角 */
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #777; /* 设置滚动条滑块在鼠标悬停时的颜色 */
}

.contract-manage {
  width: 360px;
}
</style>
